module.exports = __webpack_public_path__ + "img/pm1.50d0d485.png";